import { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import MiniHeading from '../components/MiniHeading';
import { FormGroup } from '../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { toast } from 'react-toastify';
import { VscLoading } from 'react-icons/vsc';

import { resetPasswordValidation } from '../../../../_helpers/schema-validation';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormattedMessage } from 'react-intl';

function UpdatePassword() {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(resetPasswordValidation)
  });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await fetchWrapper.post('/reset-password/', {
        password: data.confirm_password
      });
      toast.success(<FormattedMessage id="security.password_updated_successfully" />);
      setValue('password', '');
      setValue('confirm_password', '');
      setLoading(false);
    } catch (err) {
      toast.error('Something went wrong');
      setLoading(false);
      console.log(err);
    }
  };
  return (
    <div>
      <MiniHeading id="security.update-password" />
      <div className="p-2">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={2} className="d-flex align-items-center">
              <div>
                <FormattedMessage id="security.new-password" />
              </div>
            </Col>
            <Col md={4}>
              <FormattedMessage id="security.new-password_placeholder">
                {(msg) => (
                  <FormGroup
                    type="password"
                    id="password"
                    passwordType="password"
                    placeholder={msg}
                    register={register}
                    disabled={loading}
                    error={errors}
                  />
                )}
              </FormattedMessage>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={2} className="d-flex align-items-center">
              <div>
                <FormattedMessage id="security.confirm-password" />
              </div>
            </Col>
            <Col md={4}>
              <FormattedMessage id="security.confirm-password_placeholder">
                {(msg) => (
                  <FormGroup
                    type="password"
                    id="confirm_password"
                    passwordType="password"
                    placeholder={msg}
                    register={register}
                    disabled={loading}
                    error={errors}
                  />
                )}
              </FormattedMessage>
            </Col>
          </Row>
          <Row className="mt-4">
            <div>
              <Button disabled={loading} type="submit">
                {loading ? (
                  <VscLoading className="spin" />
                ) : (
                  <FormattedMessage id="security.update-password" />
                )}
              </Button>
            </div>
          </Row>
        </form>
      </div>
    </div>
  );
}

export default UpdatePassword;
